import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

// Custom hook for automatic page view tracking
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page title from document or create one based on pathname
    const getPageTitle = (pathname) => {
      const titles = {
        '/': 'Home - Expensight',
        '/pricing': 'Pricing - Expensight',
        '/contact': 'Contact - Expensight',
        '/signup-success': 'Signup Success - Expensight'
      };
      
      return titles[pathname] || `${pathname.replace('/', '').replace('-', ' ')} - Expensight`;
    };

    const pagePath = location.pathname + location.search;
    const pageTitle = getPageTitle(location.pathname);
    
    // Track page view
    trackPageView(pagePath, pageTitle);
    
    // Update document title
    document.title = pageTitle;
    
  }, [location]);
};

export default usePageTracking;